export const LINE_SPACING = [
  { name: 'Auto', value: 'auto' },
  { name: '6 pt', value: 6 },
  { name: '7 pt', value: 7 },
  { name: '8 pt', value: 8 },
  { name: '9 pt', value: 9 },
  { name: '10 pt', value: 10 },
  { name: '11 pt', value: 11 },
  { name: '12 pt', value: 12 },
  { name: '14 pt', value: 14 },
  { name: '18 pt', value: 18 },
  { name: '21 pt', value: 21 },
  { name: '24 pt', value: 24 },
  { name: '36 pt', value: 36 },
  { name: '48 pt', value: 48 },
  { name: '60 pt', value: 60 },
  { name: '72 pt', value: 72 }
];
